<script>
export default {
  props: { id: { type: Number, require: true } },

  created() {
    this.refresh()
  },

  data() {
    return {
      loading: true,
    }
  },

  computed: {
    opportunity() {
      return this.$store.getters['opportunities/find'](this.id)
    },
  },

  methods: {
    refresh() {
      this.$store.dispatch('opportunities/fetch', this.id).then(() => (this.loading = false))
    },
  },

  render() {
    return this.$scopedSlots.default({
      opportunity: this.opportunity,
    })
  },
}
</script>
